import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

/** 持牌机构 */
// 应收款列表
export const getLicensedList = (data: any) =>
  request.post('/erp/web/youka/retailAccountsReceivableInfo/listPage', data, jsonHeaderConfig)

// 应收款列表-搜索条件-结算方式
export const getRepaymentList = () =>
  request.get('/erp/web/youka/retailAccountsReceivableInfo/getRepaymentList', null)

// 应收款列表-状态
export const getState = (data: any) =>
  request.post('/erp/web/youka/retailAccountsReceivableInfo/statusCount', data, jsonHeaderConfig)

// 应收款列表-合计
export const getTotalCount = (data: any) =>
  request.post('/erp/web/youka/retailAccountsReceivableInfo/totalCount', data, jsonHeaderConfig)

// 应收款列表-详情
export const getLicensedDetail = (data: any) =>
  request.get('/erp/web/youka/retailAccountsReceivableInfo/info', data)

// 应收款列表-批量操作table
export const getLicensedTable = (data: any) =>
  request.post('/erp/web/youka/retailAccountsReceivableInfo/checkList', data, jsonHeaderConfig)

// 批量线下还款
export const repayBatchOffline = (data: any) =>
  request.post('/erp/retailReceivableDetailInfo/batchoOfflinePay', data, jsonHeaderConfig)

// 发起代偿
export const marginPay = (data: any) =>
  request.post('/erp/retailReceivableDetailInfo/marginPay', data, jsonHeaderConfig)

// 短信通知
export const sendRepayNotice = (data: any) =>
  request.get('/erp/web/youka/retailAccountsReceivableInfo/sendRepayNotice', data)

// 应收款-审批详情
export const getLicensedApproveDetail = (data: any) =>
  request.get('/erp/web/youka/retailAccountsReceivableInfo/processInfo', data)

// 应收款-审批状态数量
export const getApproveCount = () =>
  request.post(
    '/erp/web/youka/retailAccountsReceivableInfo/flowStatusCount',
    null,
    jsonHeaderConfig
  )
// 转账还款明细
export const getTransferRepayDetail = (data: any) =>
  request.post('/erp/repaymentDetails/pageList', data, {
    ...jsonHeaderConfig
  })

export const getReceivableDetails = (data: any) =>
  request.post('/erp/repaymentDetails/receivableDetails', data, {
    ...jsonHeaderConfig
  })

// 关联
export const manualLink = (data: any) =>
  request.post('/erp/repaymentDetails/manualLink', data, jsonHeaderConfig)
